import { render, staticRenderFns } from "./CryptoAddressBookModal.vue?vue&type=template&id=69b56d46&scoped=true&"
import script from "./CryptoAddressBookModal.vue?vue&type=script&lang=js&"
export * from "./CryptoAddressBookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b56d46",
  null
  
)

export default component.exports